import PortalIdParser from 'PortalIdParser';
import * as React from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { WarningIcon } from 'foundations-assets';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import SkeletonText from 'flow-doctor-lib/components/common/SkeletonText';
import LabelAndSubInfo from 'flow-doctor-lib/components/timeline/labels/LabelAndSubInfo';
import PropertySourceLabel from 'flow-doctor-lib/components/timeline/labels/PropertySourceLabel';
import usePropertiesWithOptions from 'flow-doctor-lib/hooks/usePropertiesWithOptions';
import { formatPropertyValue } from 'flow-doctor-lib/utils/propertyFormatters';
import EnrollmentChecksButton from 'flow-doctor-lib/components/timeline/EnrollmentChecksButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PROPERTY_MERGED_WARNING_SOURCES = ['MERGE_CONTACTS', 'MERGE_COMPANIES', 'MERGE_OBJECTS'];
const PropertyChangeTimelineItemLabel = ({
  logItem,
  objectTypeId
}) => {
  const propertyData = logItem.data;
  const {
    propertyWrapper,
    labelsForOptions,
    loading: propertyMapLoading,
    error: propertyMapError
  } = usePropertiesWithOptions({
    portalId: PortalIdParser.get(),
    propertyName: propertyData.name,
    objectTypeId,
    rawOptions: [propertyData.value]
  });
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(UITruncateString, {
      children: !propertyMapError && (propertyMapLoading || !propertyWrapper) ? /*#__PURE__*/_jsx(SkeletonText, {
        width: 200
      }) : /*#__PURE__*/_jsx(LabelAndSubInfo, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.flows.objectLifecycle.propertyHistory.label"
        }),
        subInfoBullets: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "flow-doctor-lib.flows.objectLifecycle.propertyHistory.subInfo",
          options: {
            propertyName: propertyWrapper ? propertyWrapper.property.label : propertyData.name,
            propertyValue: formatPropertyValue(labelsForOptions ? labelsForOptions[propertyData.value] : propertyData.value, propertyWrapper)
          }
        }, 0)]
      })
    }), propertyData.source && /*#__PURE__*/_jsx(PropertySourceLabel, {
      source: propertyData.source,
      sourceId: propertyData.sourceId
    }), PROPERTY_MERGED_WARNING_SOURCES.includes(propertyData.source) && /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "flow-doctor-lib.flows.objectLifecycle.propertyHistory.mergedWarning"
      }),
      children: /*#__PURE__*/_jsx(IconHolder, {
        icon: WarningIcon,
        color: "fill-caution-default",
        marginInlineStart: "100"
      })
    }), propertyData.source === 'MIGRATION' && /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "flow-doctor-lib.flows.objectLifecycle.propertyHistory.migrationWarning"
      }),
      children: /*#__PURE__*/_jsx(IconHolder, {
        icon: WarningIcon,
        color: "fill-caution-default",
        marginInlineStart: "100"
      })
    }), /*#__PURE__*/_jsx(EnrollmentChecksButton, {
      timelineItem: logItem
    })]
  });
};
export default PropertyChangeTimelineItemLabel;